// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/noty.scss
// module id = 5
// module chunks = 0